(ns dre.components.privacy.views
  (:require
   [dre.components.privacy.utils :as privacy]
   [dre.i18n.views :refer [tr]]
   [dre.utils.bem :as bem]
   [reagent.core :as r]))

(def component-name
  :simple-cookie-consent)

(defn privacy-notice
  []
  (let [decided? (r/atom privacy/decided-analytics?)
        reject!
        (fn [_e]
          (privacy/reject-analytics!)
          (reset! decided? true))
        accept!
        (fn [_e]
          (privacy/accept-analytics!)
          (privacy/load-analytics!)
          (reset! decided? true))]
    (fn []
      (when-not @decided?
        [:div {:class component-name}
         [:div {:class (bem/be component-name :cookie-consent-container)}
          [:div {:class (bem/be component-name :cookie-consent-notice)}
           [:h4 "Your Cookie Preferences"]
           [:hr]
           [:p [tr "Literature Search uses cookies to ensure that we give you the best possible experience on our website.
                Learn more about our"] [:a {:href privacy/privacy-pdf-url
                                            :target "_blank"}
                                        [tr " privacy policy"]] "."]]
          [:div {:class (bem/be component-name :cookie-consent-selection)}
           [:button
            {:class [(bem/bm :button :bare) :cookie-consent-deny]
             :on-click reject!}
            [:div [tr "Use Necessary Only"]]]
           [:button
            {:class [(bem/bm :button :bare) :cookie-consent-allow]
             :on-click accept!}
            [:div [tr "Allow All Cookies"]]]]]]))))
